import { render, staticRenderFns } from "./MediaPostView.vue?vue&type=template&id=fa965f0c&scoped=true&"
import script from "./MediaPostView.vue?vue&type=script&lang=ts&"
export * from "./MediaPostView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa965f0c",
  null
  
)

export default component.exports